// Mock data for frontend-only testing
// Note: Image URLs are optimized for performance (WebP format, compressed)
export const mockTestimonials = [
  {
    id: "1",
    name: "Anjali Sharma",
    rating: 5,
    text: "Acharyaa Indira Pandey's guidance helped me navigate through a difficult career transition. Her predictions were remarkably accurate and the remedies she suggested brought positive changes within months.",
    service: "Career Guidance",
    date: "2024-11-15"
  },
  {
    id: "2",
    name: "Vikram Malhotra",
    rating: 5,
    text: "I was skeptical at first, but her detailed birth chart analysis revealed insights about my personality and life path that were incredibly accurate. The gemstone recommendation has brought noticeable improvements in my health.",
    service: "Birth Chart Analysis",
    date: "2024-10-20"
  },
  {
    id: "3",
    name: "Meera Kapoor",
    rating: 5,
    text: "Her marriage compatibility reading saved my relationship. The understanding and remedies she provided helped us overcome our differences. Forever grateful for her wisdom and compassion.",
    service: "Marriage Compatibility",
    date: "2024-09-05"
  },
  {
    id: "4",
    name: "Rajesh Patel",
    rating: 5,
    text: "The Vastu consultation transformed my home's energy completely. My family relationships improved and business started flourishing. Her knowledge of Vedic sciences is truly exceptional.",
    service: "Vastu Consultation",
    date: "2024-08-12"
  }
];

export const mockServices = [
  {
    id: "1",
    title: "Birth Chart (Kundli) Analysis",
    description: "Detailed analysis of your birth chart to understand your life path, strengths, and challenges.",
    icon: "Star",
    image: "https://images.unsplash.com/photo-1515942661900-94b3d1972591?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "30 mins",
    actualPrice: 4100,
    discountPercent: 25,
    markup: 20,  // 20% markup applied to final price
    link: "/birth-chart-analysis"
  },
  {
    id: "2",
    title: "Career & Business Guidance",
    description: "Strategic insights for career growth, business decisions, and professional success.",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1729335511883-29eade10006b?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "30 mins",
    actualPrice: 3500,
    discountPercent: 25,
    markup: 20  // 20% markup applied to final price
  },
  {
    id: "3",
    title: "Marriage & Relationship Compatibility",
    description: "Comprehensive compatibility analysis for harmonious relationships and marriages.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1600429991827-5224817554f8?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "45 mins",
    actualPrice: 5100,
    discountPercent: 25,
    markup: 20  // 20% markup applied to final price
  },
  {
    id: "4",
    title: "Health & Life Path Insights",
    description: "Guidance on health matters and understanding your life's purpose and direction.",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "30 mins",
    actualPrice: 3500,
    discountPercent: 25,
    markup: 20,  // 20% markup applied to final price
    link: "/health-astrology-prediction"
  },
  {
    id: "5",
    title: "Vastu Consultation",
    description: "Home and office Vastu analysis for positive energy flow and prosperity.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1729335511904-9b8690184935?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "20-30 mins",
    actualPrice: 3000,
    discountPercent: 25,
    markup: 20  // 20% markup applied to final price
  },
  {
    id: "6",
    title: "Palmistry",
    description: "Discover insights about your personality, life path, and future through palm reading.",
    icon: "Hand",
    image: "https://images.unsplash.com/photo-1758926384162-b3783d5fa09e?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "15 mins",
    actualPrice: 2000,
    discountPercent: 25,
    markup: 20  // 20% markup applied to final price
  },
  {
    id: "7",
    title: "Gemstone Remedies & Sales",
    description: "Personalized gemstone recommendations based on your birth chart. Purchase authentic, energized gemstones directly.",
    icon: "Gem",
    image: "https://images.unsplash.com/photo-1515942661900-94b3d1972591?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "20 mins",
    actualPrice: 3500,
    discountPercent: 25,
    markup: 20  // 20% markup applied to final price
  },
  {
    id: "8",
    title: "Auspicious Childbirth Timing (Muhurat)",
    description: "Select the most auspicious and suitable time for childbirth to ensure a prosperous future for your child.",
    icon: "Baby",
    image: "https://images.unsplash.com/photo-1729335511904-9b8690184935?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "30 mins",
    actualPrice: 3500,
    discountPercent: 25,
    markup: 20  // 20% markup applied to final price
  },
  {
    id: "9",
    title: "Naming Ceremony",
    description: "Choose the perfect name for your child based on astrological calculations and numerology for a prosperous future.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1515942661900-94b3d1972591?w=800&q=80&fm=webp&fit=crop&auto=format",
    duration: "10 mins",
    actualPrice: 1100,
    discountPercent: 25,
    markup: 20  // 20% markup applied to final price
  }
];

export const mockBlogs = [
  {
    id: "1",
    title: "Understanding Your Birth Chart: A Beginner's Guide",
    excerpt: "Learn how to read and interpret your birth chart to unlock insights about your personality and life path.",
    image: "https://images.unsplash.com/photo-1515942661900-94b3d1972591?w=600&q=75&fm=webp&fit=crop&auto=format",
    author: "Acharyaa Indira Pandey",
    date: "2024-11-28",
    category: "Astrology Basics",
    readTime: "5 min read",
    externalUrl: "https://www.astrology.com/article/birth-chart-basics"
  },
  {
    id: "2",
    title: "Weekly Horoscope: December 2024",
    excerpt: "Discover what the stars have in store for you this week. Planetary movements and their impact on your zodiac sign.",
    image: "https://images.unsplash.com/photo-1729335511904-9b8690184935?w=600&q=75&fm=webp&fit=crop&auto=format",
    author: "Acharyaa Indira Pandey",
    date: "2024-12-01",
    category: "Weekly Horoscope",
    readTime: "3 min read",
    externalUrl: "https://www.astrology.com/horoscopes/daily-horoscope"
  },
  {
    id: "3",
    title: "Mercury Retrograde: What It Means for You",
    excerpt: "Understanding the effects of Mercury retrograde and how to navigate this challenging period with grace.",
    image: "https://images.unsplash.com/photo-1650365449083-b3113ff48337",
    author: "Acharyaa Indira Pandey",
    date: "2024-11-15",
    category: "Planetary Movements",
    readTime: "7 min read",
    externalUrl: "https://www.astrology.com/article/mercury-retrograde-guide"
  },
  {
    id: "4",
    title: "Vedic Remedies for Career Growth",
    excerpt: "Powerful Vedic remedies and rituals to enhance your career prospects and achieve professional success.",
    image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88",
    author: "Acharyaa Indira Pandey",
    date: "2024-10-22",
    category: "Remedies",
    readTime: "6 min read",
    externalUrl: "https://www.ganeshaspeaks.com/astrology/vedic-astrology/"
  }
];

export const mockFAQs = [
  {
    id: "1",
    question: "How accurate are your predictions?",
    answer: "With 20+ years of experience and 5000+ satisfied clients, I maintain a 95%+ accuracy rate. My predictions are based on detailed birth chart analysis, planetary positions, and Vedic astrology principles."
  },
  {
    id: "2",
    question: "Is consultation confidential?",
    answer: "Absolutely. I maintain complete confidentiality for all clients. Your personal information and consultation details are kept private and secure."
  },
  {
    id: "3",
    question: "How should I prepare before the session?",
    answer: "Please have your accurate birth details ready: date, time, and place of birth. Prepare specific questions you'd like to address. An open mind helps in receiving guidance effectively."
  },
  {
    id: "4",
    question: "What is the consultation fee?",
    answer: "Consultation fees depend on the client's requirements and type of service. Pricing varies accordingly. Please contact me for a detailed quotation based on your needs."
  },
  {
    id: "5",
    question: "Do you offer online consultations?",
    answer: "Yes, I offer both online and in-person consultations. Online sessions are conducted via video call, making it convenient for clients from anywhere."
  }
];

export const mockStats = {
  experience: "20+",
  clients: "5000+",
  satisfaction: "95%",
  consultationsPerWeek: "90-100"
};

export const astrologers = [
  {
    id: "1",
    name: "Acharyaa Indira Pandey",
    role: "Senior Vedic Astrologer",
    experience: "20+",
    specialization: ["Birth Chart Analysis", "Career Guidance", "Marriage Compatibility", "Gemstone Remedies"],
    image: "https://images.unsplash.com/photo-1554355202-11fbc45c7157?w=400&q=80&fm=webp&fit=crop&auto=format",
    bio: "With over 20 years of experience, Acharyaa Indira Pandey has guided 5000+ clients through accurate predictions and personalized remedies.",
    available: true
  },
  {
    id: "2",
    name: "Acharya Ram Nath Tiwari",
    role: "Master Astrologer & Founder",
    experience: "40+",
    specialization: ["Advanced Birth Chart Analysis", "Vedic Rituals", "Childbirth Timing", "Complex Remedies"],
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80&fm=webp&fit=crop&auto=format",
    bio: "A highly respected master astrologer with 40+ years of profound knowledge in Vedic astrology and ancient wisdom.",
    available: true
  },
  {
    id: "3",
    name: "Acharyaa Ankita Pandey",
    role: "Junior Astrologer",
    experience: "7+",
    specialization: ["Basic Consultations", "Numerology", "Vastu Basics", "Young Adults Guidance"],
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80&fm=webp&fit=crop&auto=format",
    bio: "A dedicated and enthusiastic astrologer specializing in guidance for young adults and modern life challenges.",
    available: true
  }
];

export const consultationPricing = [
  {
    duration: "Up to 10 Minutes",
    price: "Free",
    worth: "(Worth ₹1999)",
    description: "Initial consultation for first-time customers",
    features: ["Quick guidance", "Basic questions", "Understanding your concerns"],
    badge: "First Time Only"
  },
  {
    duration: "10+ Minutes",
    price: "Varies by Service",
    description: "Professional consultation based on selected service",
    features: ["Detailed analysis", "Service-specific guidance", "Personalized remedies", "Follow-up support"],
    badge: "Standard"
  }
];
